import { render } from "./UploadProductDataSidebar.vue?vue&type=template&id=452c16a0&scoped=true"
import script from "./UploadProductDataSidebar.vue?vue&type=script&lang=js"
export * from "./UploadProductDataSidebar.vue?vue&type=script&lang=js"

import "./UploadProductDataSidebar.vue?vue&type=style&index=0&id=452c16a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452c16a0"]])

export default __exports__